import React from "react";
import { number, string, bool } from "prop-types";
import "./time-stamp.m.css";

const TimeStamp = ({ timeStamp, prefix = "", showTime=true }) => {
  const options = {
    /*weekday: "short",*/
    year: "numeric",
    month: "numeric",
    day: "numeric",
    ...(showTime && { hour: "numeric", minute: "numeric" }),
    timeZone: "Europe/Helsinki", // Explicitly set the time zone
  };

  const time = new Intl.DateTimeFormat("fi-FI", options).format(new Date(timeStamp));
  return (
    timeStamp && (
      <div styleName="date-time" className="date-time">
        <span> {prefix}</span>
        <time dateTime={new Date(timeStamp).toISOString()}> {time} </time>
      </div>
    )
  );
};

TimeStamp.propTypes = {
  timeStamp: number.isRequired,
  prefix: string,
  showTime: bool
};

export default TimeStamp;
